import { useReducer, useCallback } from 'react';

import dialogActions from './dialogActions';
import dialogReducer, { initialState, dialogComponents, reducerState } from './dialogReducer';

type dialogNames = keyof typeof dialogComponents;

interface handleOpenOptions {
    callback?: ()=> void,
    delay?: number,
    selectorId?: string,
    data?: {
        [key: string]: any
    }
}

export type handleOpenType = (dialogName: dialogNames, options?: handleOpenOptions)=> void;

interface returnType {
    handleOpen: handleOpenType,
    handleClose: ()=> void,
    dialogState: reducerState
}

/**
 * Manages a dialogs state and provides function to open and close the dialog.
 * @returns {object}
 */
const useDialog = (): returnType => {
    const [state, dispatch] = useReducer(dialogReducer, initialState);

    const { status, delay } = state;

    const handleClose = useCallback(() => {
        if (status !== dialogActions.open) {
            return;
        }

        dispatch({
            type: dialogActions.closing
        });

        setTimeout(() => {
            dispatch({
                type: dialogActions.closed
            });
        }, delay);
    }, [status, delay]);

    const handleOpen = (dialogName: dialogNames, options: handleOpenOptions = {}) => {
        dispatch({
            type: dialogActions.open,
            dialogName,
            ...options
        });
    };

    return {
        handleOpen,
        handleClose,
        dialogState: state
    };
};

export default useDialog;
